export class PaginationConfig {
  predicate = 'id';
  ascending = true;
  page = 1;
  itemsPerPage = 10;
  totalItems = 0;
  maxSize = 8;
  itemsPerPageOptions = [10, 25, 50, 100];
}
